<template>
  <div class="home centered">
<!--
    <div id="genres" v-show="searcProps.genres_show" class="noselect">
        <a :class="searcProps.genres.indexOf(index) != -1 ? 'active' : ''" v-for="(genre,index) in $store.genres" v-text="genre" :key="index" @click="pushOrPull(searcProps.genres, index)"></a>
    </div>
-->


    <h1 class="title">לינקטונים שאהבת לאחרונה</h1>
    <div id="items_list">

        <h1 v-if="searcProps.q != ''">תוצאות עבור: <b v-text="searcProps.q"></b></h1>
      
      <div class="item_wrapper"  v-for="item in items" :key="item.id">
        <drag :key="item.id" class="drag" :data="item">
          <CatalogItem :item="item" @play="$emit('play', item)" @open_widget="$emit('open_widget', item)" />
        </drag>
      </div>
      
      <Loader v-if="on_loading" />


    </div>
    
  </div>
</template>

<script>

import CatalogItem from '../components/catalog/item.vue';
import Loader from '../components/loader.vue';

import { Drag } from "vue-easy-dnd";

export default {
  props: ["searcProps"],
  components: { CatalogItem, Drag, Loader},
  data(){
    return {
      artists: [],
      items: [],
      on_loading: false,
      page: 0,
      searchTimer: null,
    }
  },
  methods: {
    onDrop(e) {
      this.dropped.push(e.data);
    },
    load_results(){
      
      if (this.on_loading) return;
      
      var self = this;

			
        this.page++;

        if (this.page == 1) 
        {
          this.items = [];
        }

        this.on_loading = true;
        this.api({ action: 'vod/results', data: { is_liked:true, page: this.page, genre: this.searcProps.genres, date_from: this.searcProps.date_from, date_to: this.searcProps.date_to, q: this.searcProps.q} }, function(data){ 
          if (self.page == 1) self.artists = data.data.artists || [];
          if (self.page == 1) self.items = data.data.items; 
          else self.items.push(...data.data.items); 
          self.on_loading = false;
        });
			


    }
  },
  mounted(){
    var self = this;
    this.load_results();

    window.onscroll = () => {
      if  (!this.on_loading && document.documentElement.scrollTop + 400 >= (document.body.scrollHeight - window.innerHeight ))
			{
        self.load_results();
      }
    };

        
  },

  watch:{
    searcProps: {
      deep: true,
      handler(){ 
        this.page = 0;
        clearTimeout(this.searchTimer);
        setTimeout(() => {
          this.searchTimer = this.load_results();
        }, 500);
        
      }
    }
  }
  
}
</script>

<style lang="scss">


</style>